import React, { Suspense, useEffect, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import ProfileForm from '@/components/Profile/ProfileForm';
import { updateUserProfile } from './function';
import { message } from 'antd';
import Spinner from '@/components/Spinner';
import { Helmet } from 'react-helmet-async';

interface ProfileContextType {
  user: {
    fullname: string;
    email: string;
    phone?: string;
    gender?: number;
    birthday?: string;
    job_title?: string;
    avatar_url?: string;
  };
}

const EditProfileTab: React.FC = () => {
  const { user } = useOutletContext<ProfileContextType>();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (data: any) => {
    setLoading(true);
    try {
      await updateUserProfile(data);
    } catch (error) {
      message.error('Đã xảy ra lỗi khi cập nhật hồ sơ.');
    } finally {
      setLoading(false);
      window.location.reload();
    }
  };

  useEffect(() => {
    console.log('User data in EditProfileTab:', user);
  }, [user]);

  const handleCancel = () => {
    window.location.reload();
  };

  return (
    <Suspense  fallback={<Spinner />}>
      <Helmet>
        <title>Chỉnh sửa hồ sơ | BEQ Reward</title>
      </Helmet>
      <ProfileForm
        initialData={user}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        loading={loading}
      />
    </Suspense>
  );
};

export default EditProfileTab;
